import Vue from 'vue'
import axios from 'axios'
import {sorterParamsStr, md5Sign} from "@/assets/utils/sign.js"
import {
    Dialog,
    Toast
} from 'vant'

import router from '@/router/index.js'

// create an axios instance
//柳州妇幼
// let url =  process.env.NODE_ENV === 'production' ? '/tjwx/api' : '/api'

const service = axios.create({
    // baseURL: api.base_api, // url = base url + request url
    // baseURL: window.g.VUE_APP_URL,
    withCredentials: true, // send cookies when cross-domain requests
    // crossDomain:true,//设置允许跨域
    changeOrigin: true,
    timeout: 50000, // request timeout
})

let configChace = null; // 存放请求参数，在进入错误时候也关掉loading
// request拦截器 request interceptor
service.interceptors.request.use(
    config => {
        // 判断当前请求是否设置了不显示Loading,默认显示
        if (!config.hideLoading) {
            // window.toastTimer = setTimeout(function (){
            Toast.loading(); // 如果设置了targer,使用设置的target,比如el-table
            // },1000);
            configChace = config;

        }
        // 把不需要登录的请求排除掉
        const excludeFilter = []
        excludeFilter.push("/home")
        excludeFilter.push("/register")
        excludeFilter.push("/getReportBase64Str")
        excludeFilter.push("/getCurrentCheckUserInfoBySeriaoNo")
        excludeFilter.push("/getProcGetQueueAll")
        excludeFilter.push("/getProcCheckProgress")
        excludeFilter.push("/url")
        excludeFilter.push("/package/getTopPackageList")
        excludeFilter.push("/getDefualtPackage")
        excludeFilter.push("/pay/getPayUrlBySerialno")
        excludeFilter.push("/pay/getPayDetailBySerialno")
        excludeFilter.push("/pay/toIcbcPay")

        // console.log(config.url)


        //接口访问签名认证
        let time_stamp = new Date().getTime();
        let sortSignStr = ""
        // console.log(config.params)
        if (config.params != null) {
            sortSignStr = sorterParamsStr(config.params) + "&"
        }
        //sign放入header中
        config.headers['timestamp'] = time_stamp


        //参数进行ASCII排序后进行字符串拼接 参数字符串+时间戳+盐
        // console.log("加密前:" + sortSignStr + time_stamp + SALT)
        // console.log("与服务器比较：" + md5("1686730795756akjsdfakjdfbiasjdfbiksj"))
        // console.log("md5Sign(诺康云)：" + md5Sign("诺康云"))
        // console.log("md5Sign：" + md5Sign("1686730795756akjsdfakjdfbiasjdfbiksj"))
        // console.log("加密后:" + md5Sign(sortSignStr + time_stamp + window.g.VUE_APP_MD5_SALT))
        //参数签名key，需与后台保持一致
        let sign = md5Sign(sortSignStr + time_stamp);
        // console.log(sortSignStr + time_stamp + SALT);
        config.headers['sign'] = sign


        // if(!excludeFilter.includes(config.url)){
        //    let loginuser = JSON.parse(localStorage.getItem("loginuser"));
        //    if (loginuser == null || loginuser.name == '') {
        //        router.push({name: 'login'})
        //    }
        // }
        // if (store.getters.token) {
        //     config.headers['Authorization'] = store.getters.token
        // }
        if (localStorage.getItem("token")) {
            config.headers['Authorization'] = localStorage.getItem("token")
        }
        return config
    },
    error => {
        if (!configChace.hideLoading) {
            clearTimeout(toastTimer);
            Toast.clear();
            configChace = null;
        }
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)
// respone拦截器
service.interceptors.response.use(
    response => {
        // 判断当前请求是否设置了不显示Loading（不显示自然无需隐藏）
        if (!response.config.hideLoading) {
            // clearTimeout(toastTimer);
            Toast.clear();
        }
        const res = response.data
        // 这里注意修改成你访问的服务端接口规则
        if (res.code && res.code == 501) {
            localStorage.removeItem("loginuser")
            localStorage.removeItem("token")
            router.push({name: 'login'})
            Toast.fail(res.msg);
            return
        }
        if (res.code && res.code == 510) {
            Toast.fail(res.msg);
            return
        }
        if (res.code && res.code == 511) {
            Dialog.alert({
                title: '提示',
                message: res.msg
            }).then(() => {
                // 清空本地存储
                localStorage.removeItem("token")
                localStorage.removeItem("loginuser")
                router.push({name: 'login'})
            })
            return
        }
        if (res.code && res.code == 500) {
            Toast.fail(res.msg);
            return Promise.reject(res || 'error')
        } else {
            return Promise.resolve(res)
        }
    },
    error => {
        // eslint-disable-next-line no-debugger
        // 关闭loading
        if (configChace.hideLoading) {
            clearTimeout(toastTimer);
            Toast.clear();
            configChace = null;
        }
        // Toast.fail('操作失败，请联系体检中心进行维护');
        // 处理网络错误
        if (error.response) {
            switch (error.response.status) {
                case 404:
                    Toast.fail('请求资源不存在');
                    break;
                case 500:
                    Toast.fail('服务器内部错误，请联系体检中心进行维护');
                    break;
                case 502:
                    Toast.fail('网关错误，请联系体检中心进行维护');
                    break;
                case 503:
                    Toast.fail('服务不可用，请联系体检中心进行维护');
                    break;
                case 504:
                    Toast.fail('网关超时，请联系体检中心进行维护');
                    break;
                default:
                    Toast.fail(`连接错误 ${error.response.status}`);
            }
        } else if (error.request) {
            // 请求已发出但没有收到响应
            Toast.fail('网络连接超时，请切换数据网络再试');
        } else {
            // 其他错误
            Toast.fail('操作失败，请联系体检中心进行维护');
        }
        // Toast.fail('The operation fails. Contact the physical examination center for maintenance');
        return Promise.reject(error)
    }
)

export default service
